#@import Booking.Views.PickerElement
#@import Booking.Presenters.PartySize
#@export Booking.Views.PartySize

class Booking.Views.PartySize extends Booking.Views.PickerElement

  presenter: Booking.Presenters.PartySize

  templateName: 'partysize'

  tagName: 'li'
